import type { Trigger } from './types';

export const elementInViewport: Trigger = (
  triggerName = 'elementInViewport',
  selector
) => {
  if (!window.IntersectionObserver) {
    return (activate) => activate(triggerName);
  }

  return (activate) => {
    const targetElement = document.querySelector(String(selector));

    if (!targetElement) {
      console.error(`Can't get element by CSS selector "${selector}"`);
      return;
    }

    let observer: IntersectionObserver | null = null;

    const listener: IntersectionObserverCallback = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          if (observer) observer.disconnect();
          activate(triggerName);
        }
      }
    };

    observer = new IntersectionObserver(listener);
    observer.observe(targetElement);

    return () => observer?.disconnect();
  };
};
